import React from 'react';
import HeroSection from '../components/home/HeroSection';
import Offerings from '../components/home/Offerings';
import Export from '../components/home/Export';
import ShipStoresSupply from '../components/home/ShipStoresSupply';
import AboutUs from '../components/home/AboutUs';
import InnovativeSolutions from '../components/home/InnovativeSolutions';
import OurTeam from '../components/home/OurTeam';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <Offerings />
      <Export />
      <ShipStoresSupply />
      <AboutUs />
      <InnovativeSolutions />
      <OurTeam />
    </div>
  );
};

export default Home;